<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Issues
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
            <span>Select the issues that you’d like to test out as umbrella messages for your ad campaign. We recommend 2-3 issues per campaign</span>
          </v-tooltip>
        </h1>
        <v-row>
          <issues-block
            title="Issues that you stand for"
            :issues="mainIssues"
            @selectIssue="markIssueAsSelected"
          ></issues-block>
          <issues-block
            title="Oppositional issues"
            :issues="oppositionalIssues"
            @selectIssue="markOppositeIssueAsSelected"
          ></issues-block>
        </v-row>
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row>
        <v-btn @click="previousPage">Previous</v-btn>
        <v-spacer />
        <v-btn
          @click="nextPage"
          color="primary"
        >Next</v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import IssuesBlock from './IssuesBlock.vue'
  export default {
    name: 'issues',
    components: { IssuesBlock },
    data () {
      return {
        mainIssues: [
          {
            id: 1,
            name: 'Candidate Profile',
            selected: false
          },
          {
            id: 2,
            name: 'Education',
            selected: false
          },
          {
            id: 19,
            name: 'Environment',
            selected: false
          },
          {
            id: 3,
            name: 'Gun Safety',
            selected: false
          },
          {
            id: 4,
            name: 'Healthcare',
            selected: false
          },
          {
            id: 5,
            name: 'Immigration',
            selected: false
          },
          {
            id: 6,
            name: 'Jobs',
            selected: false
          },
          {
            id: 7,
            name: 'Justice Reform',
            selected: false
          },
          {
            id: 8,
            name: 'Pro-Choice',
            selected: false
          },
          {
            id: 20,
            name: 'Supreme Court',
            selected: false
          },
          {
            id: 9,
            name: 'Taxes',
            selected: false
          },
          {
            id: 10,
            name: 'Veterans',
            selected: false
          },
          {
            id: 11,
            name: 'Other',
            selected: false
          }
        ],
        oppositionalIssues: [
          {
            id: 12,
            name: 'Corruption',
            selected: false
          },
          {
            id: 13,
            name: 'Mitch McConnell',
            selected: false
          },
          {
            id: 14,
            name: 'Opponent is out of touch',
            selected: false
          },
          {
            id: 16,
            name: 'Republicans',
            selected: false
          },
          {
            id: 17,
            name: 'Trump',
            selected: false
          },
          {
            id: 18,
            name: 'Other',
            selected: false
          }
        ],
        valid: false
      }
    },
    props: {
      issues: {
        type: Array,
        default: () => []
      }
    },
    mounted () {
      this.findSelectedIssues()
    },
    methods: {
      findSelectedIssues () {
        this.issues.forEach(i => {
          let issue
          if (this.mainIssues.find(is => is.name === i.name)) {
            issue = this.mainIssues.find(is => is.name === i.name)
          } else if (this.oppositionalIssues.find(is => is.name === i.name)) {
            issue = this.oppositionalIssues.find(is => is.name === i.name)
          } else {
            issue = this.mainIssues.find(is => is.name === 'Other')
          }
          if (issue) issue.selected = true
        })
      },
      markIssueAsSelected (id) {
        let issue = this.mainIssues.find(i => i.id === id)
        issue.selected = !issue.selected
        if (issue.selected) {
          this.$emit('addIssue', issue)
        } else this.$emit('removeIssue', issue)
        this.validation()
      },
      markOppositeIssueAsSelected (id) {
        let issue = this.oppositionalIssues.find(i => i.id === id)
        issue.selected = !issue.selected
        if (issue.selected) {
          this.$emit('addIssue', issue)
        } else this.$emit('removeIssue', issue)
        this.validation()
      },
      validation () {
        this.valid = false
        if (this.mainIssues.concat(this.oppositionalIssues).find(item => item.selected)) this.valid = true
        return this.valid
      },
      nextPage () {
        this.$emit('next', 'issues')
      },
      previousPage () {
        this.$emit('previous')
      }
    }
  }
</script>
